import { _ as _assert_this_initialized } from "@swc/helpers/_/_assert_this_initialized";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _get } from "@swc/helpers/_/_get";
import { _ as _get_prototype_of } from "@swc/helpers/_/_get_prototype_of";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
import Hammer from "@egjs/hammerjs";
import DiscreteGestureHandler from "./DiscreteGestureHandler";
import { isnan } from "./utils";
var TapGestureHandler = /*#__PURE__*/ function(DiscreteGestureHandler) {
    "use strict";
    _inherits(TapGestureHandler, DiscreteGestureHandler);
    var _super = _create_super(TapGestureHandler);
    function TapGestureHandler() {
        _class_call_check(this, TapGestureHandler);
        var _this;
        _this = _super.apply(this, arguments);
        _define_property(_assert_this_initialized(_this), "_shouldFireEndEvent", null);
        _define_property(_assert_this_initialized(_this), "_timer", void 0);
        _define_property(_assert_this_initialized(_this), "_multiTapTimer", void 0 // TODO unused?
        );
        _define_property(_assert_this_initialized(_this), "onSuccessfulTap", function(ev) {
            if (_this._getPendingGestures().length) {
                _this._shouldFireEndEvent = ev;
                return;
            }
            if (ev.eventType === Hammer.INPUT_END) {
                _this.sendEvent(_object_spread_props(_object_spread({}, ev), {
                    eventType: Hammer.INPUT_MOVE
                }));
            }
            // When handler gets activated it will turn into State.END immediately.
            _this.sendEvent(_object_spread_props(_object_spread({}, ev), {
                isFinal: true
            }));
            _this.onGestureEnded(ev);
        });
        return _this;
    }
    _create_class(TapGestureHandler, [
        {
            key: "name",
            get: function get() {
                return "tap";
            }
        },
        {
            key: "NativeGestureClass",
            get: function get() {
                return Hammer.Tap;
            }
        },
        {
            key: "maxDelayMs",
            get: function get() {
                // @ts-ignore TODO(TS) trace down config
                return isnan(this.config.maxDelayMs) ? 300 : this.config.maxDelayMs;
            }
        },
        {
            key: "simulateCancelEvent",
            value: function simulateCancelEvent(inputData) {
                if (this.isGestureRunning) {
                    this.cancelEvent(inputData);
                }
            }
        },
        {
            key: "onGestureActivated",
            value: function onGestureActivated(ev) {
                if (this.isGestureRunning) {
                    this.onSuccessfulTap(ev);
                }
            }
        },
        {
            key: "onRawEvent",
            value: function onRawEvent(ev) {
                var _this = this;
                _get(_get_prototype_of(TapGestureHandler.prototype), "onRawEvent", this).call(this, ev);
                // Attempt to create a touch-down event by checking if a valid tap hasn't started yet, then validating the input.
                if (!this.hasGestureFailed && !this.isGestureRunning && // Prevent multi-pointer events from misfiring.
                !ev.isFinal) {
                    // Tap Gesture start event
                    var gesture = this.hammer.get(this.name);
                    // @ts-ignore TODO(TS) trace down config
                    if (gesture.options.enable(gesture, ev)) {
                        clearTimeout(this._multiTapTimer);
                        this.onStart(ev);
                        this.sendEvent(ev);
                    }
                }
                if (ev.isFinal && ev.maxPointers > 1) {
                    setTimeout(function() {
                        // Handle case where one finger presses slightly
                        // after the first finger on a multi-tap event
                        if (_this.isGestureRunning) {
                            _this.cancelEvent(ev);
                        }
                    });
                }
                if (this.hasGestureFailed) {
                    return;
                }
                // Hammer doesn't send a `cancel` event for taps.
                // Manually fail the event.
                if (ev.isFinal) {
                    // Handle case where one finger presses slightly
                    // after the first finger on a multi-tap event
                    if (ev.maxPointers > 1) {
                        setTimeout(function() {
                            if (_this.isGestureRunning) {
                                _this.cancelEvent(ev);
                            }
                        });
                    }
                    // Clear last timer
                    clearTimeout(this._timer);
                    // Create time out for multi-taps.
                    this._timer = setTimeout(function() {
                        _this.hasGestureFailed = true;
                        _this.cancelEvent(ev);
                    }, this.maxDelayMs);
                } else if (!this.hasGestureFailed && !this.isGestureRunning) {
                    // Tap Gesture start event
                    var gesture1 = this.hammer.get(this.name);
                    // @ts-ignore TODO(TS) trace down config
                    if (gesture1.options.enable(gesture1, ev)) {
                        clearTimeout(this._multiTapTimer);
                        this.onStart(ev);
                        this.sendEvent(ev);
                    }
                }
            }
        },
        {
            key: "getHammerConfig",
            value: function getHammerConfig() {
                return _object_spread_props(_object_spread({}, _get(_get_prototype_of(TapGestureHandler.prototype), "getHammerConfig", this).call(this)), {
                    event: this.name,
                    // @ts-ignore TODO(TS) trace down config
                    taps: isnan(this.config.numberOfTaps) ? 1 : this.config.numberOfTaps,
                    interval: this.maxDelayMs,
                    time: // @ts-ignore TODO(TS) trace down config
                    isnan(this.config.maxDurationMs) || this.config.maxDurationMs == null ? 250 : this.config.maxDurationMs
                });
            }
        },
        {
            key: "updateGestureConfig",
            value: function updateGestureConfig(_param) {
                var _param_shouldCancelWhenOutside = _param.shouldCancelWhenOutside, shouldCancelWhenOutside = _param_shouldCancelWhenOutside === void 0 ? true : _param_shouldCancelWhenOutside, _param_maxDeltaX = _param.maxDeltaX, maxDeltaX = _param_maxDeltaX === void 0 ? Number.NaN : _param_maxDeltaX, _param_maxDeltaY = _param.maxDeltaY, maxDeltaY = _param_maxDeltaY === void 0 ? Number.NaN : _param_maxDeltaY, _param_numberOfTaps = _param.numberOfTaps, numberOfTaps = _param_numberOfTaps === void 0 ? 1 : _param_numberOfTaps, _param_minDurationMs = _param.minDurationMs, minDurationMs = _param_minDurationMs === void 0 ? 525 : _param_minDurationMs, _param_maxDelayMs = _param.maxDelayMs, maxDelayMs = _param_maxDelayMs === void 0 ? Number.NaN : _param_maxDelayMs, _param_maxDurationMs = _param.// eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO possibly forgotten to use in updateGestureConfig?
                maxDurationMs, maxDurationMs = _param_maxDurationMs === void 0 ? Number.NaN : _param_maxDurationMs, _param_maxDist = _param.maxDist, maxDist = _param_maxDist === void 0 ? 2 : _param_maxDist, _param_minPointers = _param.minPointers, minPointers = _param_minPointers === void 0 ? 1 : _param_minPointers, _param_maxPointers = _param.maxPointers, maxPointers = _param_maxPointers === void 0 ? 1 : _param_maxPointers, props = _object_without_properties(_param, [
                    "shouldCancelWhenOutside",
                    "maxDeltaX",
                    "maxDeltaY",
                    "numberOfTaps",
                    "minDurationMs",
                    "maxDelayMs",
                    "maxDurationMs",
                    "maxDist",
                    "minPointers",
                    "maxPointers"
                ]);
                return _get(_get_prototype_of(TapGestureHandler.prototype), "updateGestureConfig", this).call(this, _object_spread({
                    shouldCancelWhenOutside: shouldCancelWhenOutside,
                    numberOfTaps: numberOfTaps,
                    maxDeltaX: maxDeltaX,
                    maxDeltaY: maxDeltaY,
                    minDurationMs: minDurationMs,
                    maxDelayMs: maxDelayMs,
                    maxDist: maxDist,
                    minPointers: minPointers,
                    maxPointers: maxPointers
                }, props));
            }
        },
        {
            key: "onGestureEnded",
            value: function onGestureEnded() {
                for(var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++){
                    props[_key] = arguments[_key];
                }
                var // @ts-ignore TODO(TS) check how onGestureEnded works
                _$_get;
                clearTimeout(this._timer);
                (_$_get = _get(_get_prototype_of(TapGestureHandler.prototype), "onGestureEnded", this)).call.apply(_$_get, [
                    this
                ].concat(_to_consumable_array(props)));
            }
        },
        {
            key: "onWaitingEnded",
            value: function onWaitingEnded(_gesture) {
                if (this._shouldFireEndEvent) {
                    this.onSuccessfulTap(this._shouldFireEndEvent);
                    this._shouldFireEndEvent = null;
                }
            }
        }
    ]);
    return TapGestureHandler;
}(DiscreteGestureHandler);
export default TapGestureHandler;
